// Typelizer digest 3a31fef590be843f801387b11ace264b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/sales_documents/:sales_document_id/duplicate */
  create: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/duplicate', params, options),
    method: 'post',
  }),
}
